const fiscalDataGateDictPT = {
  fiscalGateTitle: "Complete seus dados fiscais",
  fiscalGateDescription:
    "Para continuar usando a plataforma e podermos emitir sua fatura eletrônica automaticamente, precisamos que você complete seus dados fiscais.",
  personType: "Tipo de pessoa",
  personTypePhysical: "Pessoa física",
  personTypeLegal: "Pessoa jurídica",
  nomeFiscal: "Razão social",
  fiscalDocumentNumber: "Documento fiscal (CPF/CNPJ, Codice Fiscale ou Partita IVA)",
  fiscalDocumentNumberCPF: "CPF",
  fiscalDocumentNumberCNPJ: "CNPJ",
  fiscalDocumentNumberCodiceFiscale: "Codice Fiscale",
  fiscalDocumentNumberPartitaIVA: "Partita IVA",
  fiscalAddress: "Endereço",
  fiscalGateUnexpectedError: "Erro inesperado ao salvar seus dados fiscais.",
  fiscalGateSuccess: "Dados fiscais salvos com sucesso.",
};

export default fiscalDataGateDictPT;
